"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZGiftCardSelect = exports.ZSupportedGiftCardProviders = void 0;
const constants_1 = require("@daymade/common-lib/constants");
const types_1 = require("@daymade/common-lib/types");
const zod_1 = require("zod");
const zodSchemas_generated_1 = require("../generated/zodSchemas.generated");
exports.ZSupportedGiftCardProviders = zod_1.z.enum(constants_1.IntegratedGiftCardProviders);
exports.ZGiftCardSelect = zodSchemas_generated_1.zodSelectIntegratedGiftCard.extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectIntegratedGiftCard.shape, {
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    expiresAt: zod_1.z.coerce.date().nullable(),
}));
//# sourceMappingURL=models.js.map